interface INumber {
  value: number;
  unit?: string;
  digits?: number;
}

export const numberWithUnit = ({
  value,
  unit,
  digits = 0,
}: INumber): string => {
  let unitDisplay = {};
  switch (unit) {
    case undefined:
      break;
    case "€":
      unitDisplay = {
        style: "currency",
        currency: "EUR",
      };
      break;
    case "km":
      unitDisplay = {
        style: "unit",
        unit: "kilometer",
      };
      break;
    default:
      unitDisplay = {
        style: "unit",
        unit,
      };
  }
  const result = new Intl.NumberFormat("de-DE", {
    ...unitDisplay,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
  return result;
};
